var cell_default = {
  "cell": "UHDNe",
  "header": "HKqjx",
  "selected": "XiyHx",
  "editing": "zRR-m",
  "singleSelection": "_0sUkY",
  "hideLastBlock": "tjtRk",
  "editorWrapper": "Y6l0h",
  "viewerWrapper": "sTyq-",
  "hideFirstBlock": "_9nII2",
  "editor": "P9v4E",
  "edit": "LER7F",
  "view": "WHbVW",
  "editingToolbarWrapper": "T0RxI",
  "selectAll": "bpAbC",
  "disableSelection": "ynxNr"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
